import { useSelector } from 'react-redux';
import { RootState } from '../types';

/**
 * Returns the effective workspace ID for the current context.
 * If an admin has selected a workspace via the switcher, that takes priority.
 * Otherwise, falls back to the current user's own workspace ID.
 */
export const useEffectiveWorkspaceId = (): number | null => {
  const selectedWorkspace = useSelector((state: RootState) => state.workspaces.selectedWorkspace);
  const currentUser = useSelector((state: RootState) => state.profile.user);
  return selectedWorkspace?.id ?? currentUser?.workspaceId ?? null;
};
